import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../kms.service';
import { InstanceModuleService } from '../../serves/instance/instance.module';
import { KmsEnum } from '../../serves/kms-enum';
import { environment } from 'src/environments/environment';
declare let $: any;
@Component({
  selector: 'app-quick-add-relation',
  templateUrl: './quick-add-relation.component.html',
  styleUrls: ['./quick-add-relation.component.css']
})
export class QuickAddRelationComponent implements OnInit {

  // 接收父组件的数据：素材内容
  @Input() materialContent: any;
  // 向父组件传值
  @Output() componentState = new EventEmitter();
  // 向父组件传值最小化
  @Output() smallModal = new EventEmitter();
  // 操作类型：新增、编辑
  addOrUpdate:string = '';
  
  // 概念模型数据
  ontologyTreeDatas = [];
  // 概念模型树，默认不可选中的父级概念结点
  readonlySelfIds = [];
  // 关系模型树
  relationTreeData = [];
  // 关系模型树，默认不可选中的父级关系结点
  readonlyRetionSelfIds = ["0"];
  // 关系详细数据
  relationDatas = {
    // 起始实体数据信息
    sourceProperties: {
      nodeName: "",
      conceptId: "",
      conceptName: "",
    },
    // 指向实体数据信息
    targetProperties: {
      nodeName: "",
      conceptId: "",
      conceptName: "",
    },
    // 关联关系数据
    properties: {
      startDate: "", // 起始时间
      startDateNote: "", // 起始时间备注
      endDate: "", // 结束时间
      endDateNote: "", // 结束时间备注
      parentId: "", // 关系父级ID
      relationshipId: "", // 关系ID
      relationshipName: "", // 关系名称
      reverseRelationName: "", // 反向关系名称
      relationAlias: "",  // 关系简称 正向
      reverseRelationAlias: "", // 关系简称 反向
      uuid: "", // 当前数据ID
      materialId:'', // 关系来源
      description: "", // 关联备注
      sourceMaterial:'',
      pageNum:null,
      relPageNum:null,
      dataSource:''
    },
    sourceUUID: "", // 起始实体ID
    targetUUID: "", // 指向实体ID
  };
  // 实体关系其它内容，时间框验证
  errorList = [];
  // 实体关系其它内容，时间月数据
  monthArr = new Array(12).fill("").map((item, index) => index + 1);
  // 实体关系其它内容，时间天数据
  dayArr = [];
  // 保存按钮是否可用
  clickEnable = true;
  // 是否展示素材列表
  showMaterials = false;
  keyword = '';
  materialList = [];
  // 数据来源是否必填
  isSourceRequired = environment.isSourceRequired;
  materialCategory = "FILE_TYPE_DOCUMENT";
  fileCategoryOptions = [];
  constructor(
    private kmsService: KmsService,
    private jwt: SwJwtService,
    private message: SwMassageBoxService,
    private instanceModuleService: InstanceModuleService) { }

  ngOnInit() {
    this.fileCategoryOptions = [{ id: "FILE_TYPE_ALL", text: "全部" }];
    this.fileCategoryOptions = this.fileCategoryOptions.concat(
      this.instanceModuleService.getResourceTypeOptions()
    );
    this.getConceptTree();
  }
  
  ngOnChanges() {
    this.addOrUpdate = this.materialContent.upOrAdd == 'Add' ? 'add' : 'edit';
    // 关系新增
    if (this.addOrUpdate === 'edit'){
      let params = {
          startNodeId: this.materialContent.relationData.sourceUUID,
          uuid: this.materialContent.relationData.properties.uuid,
      }
      this.getRelationshipById(params);
    }
  }

  // 头部按钮点击事件
  clickToolbar(state,disabled){
    if(state != 'close' && disabled){
        this.message.waring('请检查所有必填项是否填写完整！');
        return;
    }
    switch(state){
        case 'save': {
            // 保存信息
            this.onSubmit();
            break;
        }
        case 'small': {
            this.componentState.emit(state);
            break;
        }
        case 'close': {
            this.componentState.emit(state);
            break;
        }
    }
  }

  // 根据关系ID查询关系详细数据
  getRelationshipById(params) {
    this.kmsService.getRelationshipById(params).subscribe(
        result => {
            if (result.code == 200) {
                let datas = result.data;
                this.relationDatas = datas;
                let properties = this.relationDatas.properties ? this.relationDatas.properties : null;
                this.relationDatas.properties.pageNum = properties.pageNum && properties.pageNum > 0 ? properties.pageNum : null;
                this.relationDatas.properties.relPageNum = properties.relPageNum && properties.relPageNum > 0 ? properties.relPageNum : null;
                this.getRelationTreeData();
            } else {
                this.message.waring("数据错误，请稍后再试！");
            }
        }
    )
  }

  // 查询概念数据
  getConceptTree() {
    this.kmsService.getConceptTreeData({}).subscribe((data) => {
      if (data.code == 200) {
        if (!data.data) {
          this.ontologyTreeDatas = [];
        }
        this.ontologyTreeDatas = data.data;
        this.readonlySelfIds = ["0"];
        this.ontologyTreeDatas.forEach((item) => {
          if (!item.parentId) {
            item.parentId = "0";
            item.pid = item.parentId;
          } else {
            item.pid = item.parentId;
          }
          if (
            this.ontologyTreeDatas.filter((item1) => item1.pid == item.id)
              .length > 0
          ) {
            this.readonlySelfIds.push(item.id);
          }
        });
        const rootNode = {
          id: "0",
          pid: null,
          text: "概念配置",
        };
        this.ontologyTreeDatas.push(rootNode);
      }
    });
  }

  // 查询关系树数据
  getRelationTreeData() {
    let params = {
      sourceConceptId: this.relationDatas.sourceProperties.conceptId,
      targetConceptId: this.relationDatas.targetProperties.conceptId,
    };
    // 查询左侧关系树数据
    this.kmsService.getRelationTreeListPrefix(params).subscribe((data) => {
      if (data.code == "200") {
        if (!data.data) {
          this.message.danger("当前关系名称不存在！");
          return;
        }
        data.data.forEach(element => {
          element['text'] = element['reverseName'] ? element['name']+"（"+element['reverseName']+"）" : element['name'];
        });
        this.relationTreeData = data.data;
        this.readonlyRetionSelfIds = ["0"];
        this.relationTreeData.forEach((item) => {
          if (!item.pid) {
            item.pid = "0";
          }
          // 根据是否有父级判断是否为概念组节点，概念组节点不可选择
          if (
            this.relationTreeData.filter((item1) => item1.id == item.pid)
              .length == 0
          ) {
            this.readonlyRetionSelfIds.push(item.id);
          }
        });
      }
    });
  }

  // 概念下拉切换选中方法
  // type = 0为起始实体概念切换，type = 1为指向实体概念切换
  handleConceptChange(event, type) {
    if (type == 1) {
      // 获取指向概念
      this.relationDatas.targetProperties.conceptId = event.id;
      this.relationDatas.targetProperties.conceptName = event.text;
      // 清空指向实体
      this.relationDatas.targetProperties.nodeName = '';
      this.relationDatas.targetUUID = '';
    } else {
      // 获取起始概念
      this.relationDatas.sourceProperties.conceptId = event.id;
      this.relationDatas.sourceProperties.conceptName = event.text;
      // 清空起始实体
      this.relationDatas.sourceProperties.nodeName = '';
      this.relationDatas.sourceUUID = '';
    }
    // 清空关系
    this.relationTreeData = [];
    this.relationDatas.properties.relationshipId = '';
    this.relationDatas.properties.relationshipName = '';
    this.relationDatas.properties.reverseRelationName = '';
    this.relationDatas.properties.relationAlias = '';
    this.relationDatas.properties.reverseRelationAlias = '';
    this.relationDatas.properties.parentId = '';
    // 如果起始实体概念和指向实体概念都存在
    if (this.relationDatas.sourceProperties.conceptName && this.relationDatas.targetProperties.conceptName) {
      this.getRelationTreeData();
    }
  }

  // 概念清空方法
  // type = 0为起始实体概念切换，type = 1为指向实体概念切换
  handleConceptClear(event, type) {
    if (type == 1) {
      // 清空指向概念
      this.relationDatas.targetProperties.conceptId = '';
      this.relationDatas.targetProperties.conceptName = '';
      // 清空指向实体
      this.relationDatas.targetProperties.nodeName = '';
      this.relationDatas.targetUUID = '';
    } else {
      // 清空起始概念
      this.relationDatas.sourceProperties.conceptId = '';
      this.relationDatas.sourceProperties.conceptName = '';
      // 清空起始实体
      this.relationDatas.sourceProperties.nodeName = '';
      this.relationDatas.sourceUUID = '';
    }
    // 清空关系
    this.relationTreeData = [];
    this.relationDatas.properties.relationshipId = '';
    this.relationDatas.properties.relationshipName = '';
    this.relationDatas.properties.reverseRelationName = '';
    this.relationDatas.properties.relationAlias = '';
    this.relationDatas.properties.reverseRelationAlias = '';
    this.relationDatas.properties.parentId = '';
  }

  // 关系下拉切换选中方法
  handleRelationChange(event) {
    // 赋值当前选中的关系名称
    let items = this.relationTreeData.filter(el => el.id == event.id);
    this.relationDatas.properties.relationshipName = items[0].name;
    this.relationDatas.properties.reverseRelationName = items[0].reverseName;
    this.relationDatas.properties.relationAlias = items[0].relationAlias ? items[0].relationAlias : '';
    this.relationDatas.properties.reverseRelationAlias = items[0].reverseRelationAlias ? items[0].reverseRelationAlias : '';
  }

  // 起始实体或指向实体发生变化
  handleInstanceChange(event,type){
    if (type == 1) {
      this.relationDatas.targetProperties.nodeName = event.text;
    } else {
      this.relationDatas.sourceProperties.nodeName = event.text;
    }
  }

  // 交换起始实体与指向实体
  changeDirection(){
    // 交换起始、指向实体
    let sourceUUID = this.relationDatas.sourceUUID;
    this.relationDatas.sourceUUID = this.relationDatas.targetUUID;
    this.relationDatas.targetUUID = sourceUUID;
    if(this.relationDatas.sourceProperties.conceptId != this.relationDatas.targetProperties.conceptId){
      // 交换起始、指向概念
      let startConcept = JSON.parse(JSON.stringify(this.relationDatas.sourceProperties));
      this.relationDatas.sourceProperties = JSON.parse(JSON.stringify(this.relationDatas.targetProperties));
      this.relationDatas.targetProperties = startConcept;
      // 清空关系
      this.relationTreeData = [];
      this.relationDatas.properties.relationshipId = '';
      this.relationDatas.properties.relationshipName = '';
      this.relationDatas.properties.reverseRelationName = '';
      this.relationDatas.properties.relationAlias = '';
      this.relationDatas.properties.reverseRelationAlias = '';
      this.relationDatas.properties.parentId = '';
      // 如果起始实体概念和指向实体概念都存在
      if (this.relationDatas.sourceProperties.conceptName && this.relationDatas.targetProperties.conceptName) {
        this.getRelationTreeData();
      }
    }
  }

  // 获取时间中的年月日
  getYearOrMonthOrDay(key, dateStr) {
    let data;
    if (!dateStr) {
      data = {
        year: "",
        month: "",
        day: "",
      };
    } else {
      const dateArr = dateStr.split("/");
      const len = dateArr.length;
      data = {
        year: len > 0 ? dateArr[0] : "",
        month: len > 1 ? dateArr[1] : "",
        day: len > 2 ? dateArr[2] : "",
      };
      if (dateArr[0] && dateArr[1]) {
        this.dayArr = this.instanceModuleService.getDayDatas(
          dateArr[0],
          dateArr[1]
        );
      }
    }
    return data[key];
  }

  // 获取年号
  getTime(name) {
    let parent = $('input[name="' + name + '"]').parent();
    const value = parent.find(".year").val();
    if (value) {
      if (value > 1949) {
        if (name == "startDate") {
          // 发生时间
          this.relationDatas.properties.startDateNote = `${value}年`;
        } else {
          // 结束时间
          this.relationDatas.properties.endDateNote = `${value}年`;
        }
      } else {
        this.kmsService.getInstanceTimeNoteByYear(value).subscribe((data) => {
          if (data.code == "200") {
            const res = data.data;
            if (name == "startDate") {
              // 发生时间
              this.relationDatas.properties.startDateNote = res;
            } else {
              // 结束时间
              this.relationDatas.properties.endDateNote = res;
            }
          } else {
            this.message.waring(data.msg);
          }
        });
      }
    }
  }

  // 将年月日拼接成字符串
  getDateStr(keyName) {
    let parent = $('input[name="' + keyName + '"]').parent();
    const yearValue = parent.find(".year").val();
    const monthValue = parent.find(".month").val();
    const dayValue = parent.find(".day").val();

    let res = this.instanceModuleService.validateTime(
      yearValue,
      monthValue,
      dayValue
    );
    if (keyName == "startDate") {
      // 发生时间
      this.relationDatas.properties.startDate = res.timeStr;
    } else {
      // 结束时间
      this.relationDatas.properties.endDate = res.timeStr;
    }

    let item = {};
    item[keyName] = res.timeStr;
    if (!res.isValid) {
      if (this.errorList.indexOf(keyName) < 0) {
        this.errorList.push(keyName);
        parent.parent().find(".tip-error").removeClass("hidden");
        parent.find(".year,.month,.day").addClass("input-error");
      }
    } else {
      const index = this.errorList.indexOf(keyName);
      if (index >= 0) {
        this.errorList.splice(index, 1);
        parent.parent().find(".tip-error").addClass("hidden");
        parent.find(".year,.month,.day").removeClass("input-error");
      }
    }
  }

  // 选中素材内容，填充到输入框中
  handleFillClick() {
    let data = this.jwt.getToken('materialTextSelect') ? JSON.parse(this.jwt.getToken('materialTextSelect')) : null;
    if(data){
      this.relationDatas.properties["materialId"] = data.materialId;
      this.relationDatas.properties["description"] = data.sourceText;
      this.relationDatas.properties["sourceMaterial"] = data.sourceMaterial;
      this.relationDatas.properties["pageNum"] = data.pageNum;
      this.relationDatas.properties["relPageNum"] = data.relPageNum;
      this.relationDatas.properties["dataSource"] = data.datasource;
    }
    this.jwt.setToKen('materialTextSelect','');
  }

  toggleMaterial(state){
    this.showMaterials = state;
  }

  setMaterial(item){
    this.relationDatas.properties.materialId = item.materialId;
    this.relationDatas.properties.sourceMaterial = item.materialTitle;
    this.showMaterials = false;
  }

  //enter键触发搜索
  enterSearch(event) {
    if (event.keyCode == '13') {
      this.searchMaterial();
    }
  }

  searchMaterial(){
    let keyword = $.trim(this.keyword);
    if(!keyword){
      this.message.danger('请输入素材名称！');
      return;
    }
    let params = {
      current: 1,
      size: 30,
      materialTitle: keyword,
      materialCategory: this.materialCategory == 'FILE_TYPE_ALL' ? '' : this.materialCategory
    }
    this.kmsService.queryMaterialList(params).subscribe(
      data => {
        if (data.code == '200') {
          this.materialList = data.data.records ? data.data.records : [];
        } else {
          console.log(data.msg);
        }
      }
    );
  }

  clear(){
    this.relationDatas.properties.materialId = '';
    this.relationDatas.properties.sourceMaterial = '';
  }

  // 新增、编辑关系（单条操作)
  onSubmit() {
    this.clickEnable = false;
    let params = {
      "relationship": this.relationDatas.properties,
      "sourceUUID": this.relationDatas.sourceUUID,
      "targetName": this.relationDatas.targetProperties.nodeName,
      "targetUUID": this.relationDatas.targetUUID
    }
    this.kmsService.saveRelationshipUpdate(params).subscribe((data) => {
      this.clickEnable = true;
      if (data.code == "200") {
        this.message.success("操作成功！");
        this.componentState.emit('save');
      } else {
        this.message.waring(data.msg);
      }
    });
  }
}
